(function () {
    angular
        .module("dashboard")
        .controller("OrderUpDelayOrderModalController", [
            "$scope",
            "$uibModalInstance",
            "isCollect",
            "timeOptions",
            "setDelayTime",
            "delayTime",
            OrderUpDelayOrderModalController]);

    function OrderUpDelayOrderModalController(
        $scope,
        $uibModalInstance,
        isCollect,
        timeOptions,
        setDelayTime,
        delayTime
    ) {
        $scope.isCollect = isCollect;
        $scope.timeOptions = timeOptions.filter(option => option.value !== 0);
        $scope.selectedTime = delayTime || $scope.timeOptions[0].value;
        $scope.closeModal = () => {
            $uibModalInstance.close();
        }
        $scope.confirmTime = function (){
            setDelayTime($scope.selectedTime);
            $scope.closeModal();
        }
        $scope.mode = () => {
            return isCollect ? "collect" : "delivery";
        }
    }
})();
